import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { TARA_CHAT_API_BASE_URL } from '../../constants/central-api';

interface SystemInstructionPayload {
  general?: {
    chat?: string;
    graphs?: string;
  };
  integrations?: {
    calculator?: string;
    calendar?: string;
    google_analytics?: string;
    facebook_ads?: string;
    google_ads?: string;
    linkedin_ads?: string;
    tiktok_ads?: string;
    adup_ai_tracking?: string;
    intercom?: string;
    woocommerce?: string;
    google_search_console?: string;
    shopify?: string;
    hubspot?: string;
    stripe?: string;
    recommendations?: string;
  };
}

export default async function put_system_instruction_api_call(
  payload: SystemInstructionPayload
) {
  const accessToken = store.getState().auth.authorization.accessToken;
  const sellerToken = accessToken?.sellerToken;

  const requestInfo: RequestInfo = {
    url: `${TARA_CHAT_API_BASE_URL}system-prompt`,
    method: 'PUT',
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'PUT_SYSTEM_INSTRUCTION';
  const customMsg = 'System instruction updated successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );
  const response = res?.data;
  if (!response?.success) {
    return false;
  }
  if (res.actionType === actionType && response.success === true) {
    return response.data || null;
  }
}
